type PropTypes = {
  className?: string,
  ariaHidden?: boolean
}

const BrandIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 713 535"
      className={className}
    >
      <path
        fill="#fff"
        stroke="#CFD3DE"
        d="M450.5 12.5c12.614 0 22.613 9.98 25.168 22.465 21.139 103.286 102.327 184.636 205.409 205.816 12.459 2.56 22.423 12.578 22.423 25.219 0 12.641-9.964 22.659-22.423 25.219C577.995 312.4 496.807 393.75 475.668 497.034 473.113 509.52 463.114 519.5 450.5 519.5c-12.615 0-22.614-9.98-25.169-22.466C404.193 393.75 323.004 312.4 219.921 291.219 207.462 288.659 197.5 278.641 197.5 266c0-12.641 9.962-22.659 22.421-25.219 103.083-21.18 184.272-102.53 205.41-205.815C427.886 22.48 437.885 12.5 450.5 12.5Z"
      />
      <path
        fill="#fff"
        stroke="#CFD3DE"
        d="M418.5 12.5c12.614 0 22.613 9.98 25.168 22.465 21.139 103.286 102.327 184.636 205.409 205.816 12.459 2.56 22.423 12.578 22.423 25.219 0 12.641-9.964 22.659-22.423 25.219C545.995 312.4 464.807 393.75 443.668 497.034 441.113 509.52 431.114 519.5 418.5 519.5c-12.615 0-22.614-9.98-25.169-22.466C372.193 393.75 291.004 312.4 187.921 291.219 175.462 288.659 165.5 278.641 165.5 266c0-12.641 9.962-22.659 22.421-25.219 103.083-21.18 184.272-102.53 205.41-205.815C395.886 22.48 405.885 12.5 418.5 12.5Z"
      />
      <path
        fill="#fff"
        stroke="#CFD3DE"
        d="M387.5 12.5c12.614 0 22.613 9.98 25.168 22.465 21.139 103.286 102.327 184.636 205.409 205.816 12.459 2.56 22.423 12.578 22.423 25.219 0 12.641-9.964 22.659-22.423 25.219C514.995 312.4 433.807 393.75 412.668 497.034 410.113 509.52 400.114 519.5 387.5 519.5c-12.615 0-22.614-9.98-25.169-22.466C341.193 393.75 260.004 312.4 156.921 291.219 144.462 288.659 134.5 278.641 134.5 266c0-12.641 9.962-22.659 22.421-25.219 103.083-21.18 184.272-102.53 205.41-205.815C364.886 22.48 374.885 12.5 387.5 12.5Z"
      />
      <path
        fill="#fff"
        stroke="#CFD3DE"
        d="M355.5 12.5c12.614 0 22.613 9.98 25.168 22.465 21.139 103.286 102.327 184.636 205.409 205.816 12.459 2.56 22.423 12.578 22.423 25.219 0 12.641-9.964 22.659-22.423 25.219C482.995 312.4 401.807 393.75 380.668 497.034 378.113 509.52 368.114 519.5 355.5 519.5c-12.615 0-22.614-9.98-25.169-22.466C309.193 393.75 228.004 312.4 124.921 291.219 112.462 288.659 102.5 278.641 102.5 266c0-12.641 9.962-22.659 22.421-25.219 103.083-21.18 184.272-102.53 205.41-205.815C332.886 22.48 342.885 12.5 355.5 12.5Z"
      />
      <path
        fill="#fff"
        stroke="#CFD3DE"
        d="M324.5 12.5c12.614 0 22.613 9.98 25.168 22.465 21.139 103.286 102.327 184.636 205.409 205.816 12.459 2.56 22.423 12.578 22.423 25.219 0 12.641-9.964 22.659-22.423 25.219C451.995 312.4 370.807 393.75 349.668 497.034 347.113 509.52 337.114 519.5 324.5 519.5c-12.615 0-22.614-9.98-25.169-22.466C278.193 393.75 197.004 312.4 93.921 291.219 81.462 288.659 71.5 278.641 71.5 266c0-12.641 9.962-22.659 22.42-25.219 103.084-21.18 184.273-102.53 205.411-205.815C301.886 22.48 311.885 12.5 324.5 12.5Z"
      />
      <path
        fill="#fff"
        stroke="#CFD3DE"
        d="M293.5 12.5c12.614 0 22.613 9.98 25.168 22.465 21.139 103.286 102.327 184.636 205.409 205.816 12.459 2.56 22.423 12.578 22.423 25.219 0 12.641-9.964 22.659-22.423 25.219C420.995 312.4 339.807 393.75 318.668 497.034 316.113 509.52 306.114 519.5 293.5 519.5c-12.615 0-22.614-9.98-25.169-22.466C247.193 393.75 166.004 312.4 62.921 291.219 50.462 288.659 40.5 278.641 40.5 266c0-12.641 9.962-22.659 22.42-25.219 103.084-21.18 184.273-102.53 205.411-205.815C270.886 22.48 280.885 12.5 293.5 12.5Z"
      />
      <path
        fill="#fff"
        stroke="#CFD3DE"
        d="M260.5 12.5c12.614 0 22.613 9.98 25.168 22.465 21.139 103.286 102.327 184.636 205.409 205.816 12.459 2.56 22.423 12.578 22.423 25.219 0 12.641-9.964 22.659-22.423 25.219C387.995 312.4 306.807 393.75 285.668 497.034 283.113 509.52 273.114 519.5 260.5 519.5c-12.615 0-22.614-9.98-25.169-22.466C214.193 393.75 133.004 312.4 29.921 291.219 17.462 288.659 7.5 278.641 7.5 266c0-12.641 9.962-22.659 22.42-25.219 103.084-21.18 184.273-102.53 205.411-205.815C237.886 22.48 247.885 12.5 260.5 12.5Z"
      />
    </svg>
  )
}

export default BrandIcon
